mainApp.directive('accountItem', function() {
    return {
        templateUrl: '/public/directives/accountItem.html',
        scope: {
            item: "=?",
            setPageSize: '=',
            tagspopup: "=?",
            maxThroughputTotal: "=?",
            chartsSettings: "=?"
        },
        controller: ["$scope", function($scope) {

            angular.element(document).ready(function(){
                if($scope.item.realtimeStats && $scope.item.realtimeStats[0] && $scope.item.realtimeStats[0].rtStatsList && $scope.item.realtimeStats[0].rtStatsList.length > 0){
                    $scope.updateThroughputGraph($scope.item.realtimeStats[0].rtStatsList, $scope.item.id, $scope.maxThroughputTotal);
                }
            });

            if(isSystemLogin){
                $scope.isSystemLogin = true;
            }

            $scope.showTagsPopUp = function(item,field,id){
                $scope.tagspopup($scope.item,field,id);
            };

            $scope.updateThroughputGraph = function(rtStatsList,itemId, maximum){
                if (!$scope.throughputChart && document.getElementById('throughput-chart'+itemId)){
                    $scope.throughputChart = AmCharts.makeChart('throughput-chart'+itemId, _.cloneDeep($scope.chartsSettings));
                    $scope.throughputChart.valueAxes[0].maximum = maximum;

                    var fieldName = "throughputTotal";

                    if (!$scope.throughputChart.dataProvider || $scope.throughputChart.dataProvider.length != rtStatsList.length){
                        $scope.throughputChart.dataProvider = rtStatsList;
                    }
                    var bucket = 0;

                    rtStatsList.forEach(function(dataItem){
                        if(rtStatsList && rtStatsList.length > 0 && $scope.throughputChart.dataProvider[0].sampleTime != rtStatsList[0].sampleTime){
                            $scope.throughputChart.dataProvider[bucket].sampleTime = dataItem.sampleTime;
                            $scope.throughputChart.dataProvider[bucket].sampleTimeEnd = dataItem.sampleTimeEnd;
                        }
                        bucket++;
                    });

                    $scope.throughputChart.validateData();
                }
            };
        }]
    }
});